import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";
import ExecutionReport from "@/pages/CustomersExtranet/ExecutionReport";

const ExtranetMacro = () => import("../pages/ExtranetMacro/");

const mainPages = {
  path: "/",
  component: DashboardLayout,
  name: "JBClientsPages",
  icon: "group_work",
  title: "Principal",

  children: [
    {
      path: "/estatus/siniestros/",
      name: "Estatus Siniestros",
      title: "Estatus Siniestros",
      component: ExtranetMacro,
      meta: {
        ifUserCan: {
          extranet_view: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/estatus/ejecucion",
      name: "Estatus Ejecución",
      title: "Estatus Ejecución",
      component: ExecutionReport,
      meta: {
        //:TODO: Correct expected permission if gets updated
        ifUserCan: {
          extranet: "WorkPlan/workplanreal",
          extranet: "WorkPlan/workplanexpected",
        },
      },
    },
  ],
};

export default mainPages;



// WEBPACK FOOTER //
// ./src/router/clientRoutes.js